
/* injects from baggage-loader */

'use strict';

import AccountActivityController from './account.activity.controller';
import AccountActivityTemplate from './account.activity.html';

export default class AccountActivityComponent {
		constructor() {
				this.templateUrl = AccountActivityTemplate;
				this.controller = AccountActivityController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					events: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/activity/account.activity.component.js